import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const blogs = [
  {
    date: "June 28, 2024",
    category: "Restaurant",
    title: "Best way to solve business deal issue in market.",
    image: "img/rooms/room1.jpg",
    link: "blog-details.html"
  },
  {
    date: "June 30, 2021",
    category: "Gym",
    title: "Marketing Guide 5 steps to Success",
    image: "img/rooms/room2.jpg",
    link: "blog-details.html"
  },
  {
    date: "June 16, 2021",
    category: "Spa",
    title: "Best Way to solve Business deal.",
    image: "img/rooms/room3.jpg",
    link: "blog-details.html"
  },
  {
    date: "June 10, 2025",
    category: "Golf",
    title: "Customer service stats know in 2019.",
    image: "img/rooms/room5.jpg",
    link: "blog-details.html"
  },
  // ==============


  {
    date: "June 10, 2025",
    category: "Golf",
    title: "Customer service stats know in 2019.",
    image: "img/rooms/room9.jpg",
    link: "blog-details.html"
  },

  {
    date: "June 10, 2025",
    category: "Golf",
    title: "Customer service stats know in 2019.",
    image: "img/rooms/room12.jpg",
    link: "blog-details.html"
  },
 
];

const BlogSection = () => {
  const settings = {
    infinite: true,  // Loop the carousel infinitely
    speed: 500,  // Speed of the transition in ms
    autoplay: true,  // Enable autoplay
    autoplaySpeed: 3000,  
    slidesToShow: 4,  
    slidesToScroll: 4,  
    arrows: false,  // Hide arrows (optional)
    dots: true,  // Show navigation dots
    responsive: [
      {
        breakpoint: 1024, // For screens smaller than 1024px
        settings: {
          slidesToShow: 3,  // Show 3 slides on smaller screens
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768, // For screens smaller than 768px
        settings: {
          slidesToShow: 2,  // Show 2 slides on smaller screens
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480, // For screens smaller than 480px
        settings: {
          slidesToShow: 1,  // Show 1 slide on very small screens
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
    
    <Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 |Om Sai PG|Blog| PG for Working Professionals Pune | Luxury PG in Kharadi|
Paying Guest Near Kharadi IT Park Pune
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="PG for Working Professionals Pune,Luxury PG in Kharadi,Paying Guest Near Kharadi IT Park Pune,PG Near Kharadi Eon IT Park"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

    
    <section className="section-blog padding-t-50 padding-b-100">
      <div className="container">
        <div className="row">
          <div className="col-12" data-aos="fade-up" data-aos-duration="1000">
            <div className="rx-banner text-center rx-banner-effects">
              <p>
                <img
                  src="img/banner/left-shape.svg"
                  alt="banner-left-shape"
                  className="svg-img left-side"
                />
                Om Sai PG
                <img
                  src="img/banner/right-shape.svg"
                  alt="banner-right-shape"
                  className="svg-img right-side"
                />
              </p>
              <h4>
                Our <span>Rooms</span>
              </h4>
            </div>
          </div>

          <div className="col-12" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
            <Slider {...settings} className="rx-blog-slider">
              {blogs.map((blog, index) => (
                <div key={index} className="rx-blog-card">
                  <div className="rx-blog-img">
                    <img src={blog.image} alt={`blog-${index + 1}`} />
                  </div>
                  <div className="rx-blog-contact">
                    <span>Om Sai PG</span>
                    <h4>
                      <Link to='https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking a room at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!!' target="_blank" className="book-btn">Book Now</Link>
                    </h4>
                  
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default BlogSection;
